import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import RecordTab from "components/tools/record-tab";
import { Button, Row } from "components/ui-kit/styled-templates";

import { createId } from "services/common-service";
import ModalsService from "services/modals-service";

import useFormControl from "hooks/useFormControl";

import { EForms, EModals, ESteps } from "types/enums";

const ServicesPage = () => {
    const { t } = useTranslation();

    const { dormitoryId } = useParams();
    const { data = {}, setValue } = useFormControl({ name: EForms.dormitoryInfo });
    const services = data[ESteps.Services] ?? [];

    const handlers = {
        createService: () => ModalsService.showModal(EModals.EditService, { isFree: false, id: createId() }),
        updateService: (service: any, index: number) => () => ModalsService.showModal(EModals.EditService, service),
        deleteService: (index: number) => () => {
            if (dormitoryId) {
                ModalsService.showModality({
                    title: `Удаление события`,
                    description: `Вы уверены, что хотите удалить событие?`,
                    confirmButton: {
                        children: `Удалить`,
                        background: `red`,
                        onClick: () =>
                            setValue(
                                `${ESteps.Services}`,
                                services.filter((_: any, i: number) => i !== index),
                            ),
                    },
                    cancelButton: {
                        background: `grey`,
                        children: `Отмена`,
                    },
                });
            }
        },
    };

    return (
        <>
            {services.map((item: any, index: number) => (
                <RecordTab
                    key={index}
                    title={item?.name}
                    description={item?.description}
                    tableData={[
                        // { title: `Длительность`, value: item?.duration },
                        {
                            title: `Стоимость`,
                            value: item?.isFree ? `Бесплатно` : `${item?.price} рублей`,
                        },
                    ]}
                    onEditClick={handlers.updateService(item, index)}
                    onDeleteClick={handlers.deleteService(index)}
                />
            ))}
            <Row extra={`width: inherit; justify-content: flex-start;`}>
                <Button variant="outlined" onClick={handlers.createService}>
                    {t("qbtijuh99vi")}
                </Button>
            </Row>
        </>
    );
};

export default ServicesPage;
